module.exports = __webpack_public_path__ + "static/pigly04-sq-d32375a89fec2fe4178aa2ca9c6cdd2f.png";